import { render, staticRenderFns } from "./bills-payment.vue?vue&type=template&id=164706ee"
import script from "./bills-payment.vue?vue&type=script&lang=js"
export * from "./bills-payment.vue?vue&type=script&lang=js"
import style0 from "./bills-payment.vue?vue&type=style&index=0&id=164706ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports